import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import ApplicantReviewCard from "./ApplicantReviewCard";

import { styled } from "@mui/system";
import { setActiveStep } from "../voucher-form.slice";
import PersonalDetailStepIcon from "../../../assets/component-icon/PersonalDetailStepIcon";
import ContactDetailStepIcon from "../../../assets/component-icon/ContactDetailStepIcon";
import ProfessionalDetailStepIcon from "../../../assets/component-icon/ProfessionalDetailStepIcon";

const ReviewYourDetails = () => {
  const { activeStep } = useSelector((state) => state?.voucherForm);
  const dispatch = useDispatch();

  const isMobile = useMediaQuery("(max-width: 767px)");
  const stepperRef = useRef(null);

  useEffect(() => {
    if (isMobile && stepperRef.current) {
      // if (reviewActiveStep === 2) {
      //   // Scroll to the right when the last step is active
      //   stepperRef.current.scrollTo({
      //     left: stepperRef.current.scrollWidth,
      //     behavior: "smooth",
      //   });
      // } else {
      // Scroll back to the left for other steps
      stepperRef.current.scrollTo({
        left: 0,
        behavior: "smooth",
      });
      // }
    }
  }, [isMobile]);

  // useEffect(() => {
  //   if (
  //     enquiryDetails?.data?.primarySource !== null &&
  //     typeof enquiryDetails?.data?.primarySource !== "undefined"
  //   ) {
  //     if (
  //       enquiryDetails?.data?.primarySource === "Purva Privilege" ||
  //       enquiryDetails?.data?.primarySource === "Provident Premier"
  //     ) {
  //       setSteps([
  //         ...initialSteps,
  //         {
  //           label: "Referrer Details",
  //           value: 2,
  //         },
  //       ]);
  //     }
  //   }
  // }, [enquiryDetails]);

  const handleActiveStep = (value) => {
    dispatch(setActiveStep(activeStep + 1));
  };



  return (
    <>
      <Typography
        sx={{
          color: "#1C252E",
          fontSize: "16px",
          fontWeight: "600",
          lineHeight: "36px",
          mb: "30px",
          textAlign: "center",
        }}
      >
        Review your Details
      </Typography>
      <Grid
        container
        spacing={2}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        {/* <Grid item xs={12} sm={6} md={6} lg={12} xl={12}>
          <Stepper
            activeStep={reviewActiveStep}
            orientation="horizontal"
            ref={stepperRef}
            sx={{ mb: 3 }}
            className="steeperPersonal"
          >
            {steps.map((step, index) => (
              <Step
                key={step.label}
                sx={{
                  "& .MuiStepLabel-root": {
                    color: "green",
                  },
                  "& .MuiStepLabel-label.Mui-active": {
                    color: "#1A407D",
                    fontSize: "14px",
                    fontWeight: "600",
                    lineHeight: "22px",
                  },
                  "& .MuiStepIcon-root": {
                    background: "#fff",
                    color: "#fff",
                    width: "32px",
                    height: "32px",
                    border: "2px solid #A5A5A5",
                    borderRadius: "10000px",
                    "& .css-117w1su-MuiStepIcon-text": {
                      fill: "#1A407D",
                    },
                  },
                  "& .MuiStepIcon-root.Mui-active": {
                    background: "red",
                    border: "2px solid #1A407D",
                    color: "#fff",
                  },
                }}
              >
                <StepLabel
                  onClick={() => handleActiveStep(step.value)}
                  StepIconComponent={ColorlibStepIcon}
                >
                  {step.label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Grid> */}
      </Grid>
      <div>
        <ApplicantReviewCard
          handleActiveStep={handleActiveStep}
        ></ApplicantReviewCard>
      </div>
    </>
  );
};

export default ReviewYourDetails;
